module.exports = __webpack_public_path__ + "static/media/art32.70f405eb.jpg";